module.exports = __webpack_public_path__ + "static/media/Vector1.fb200911.png";